import { useState, useCallback, useEffect } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Swal from "sweetalert2";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import styles from "./FeedbackDrawer.module.scss";
import { toSentenceCase } from "../../utils/utils";
import { getCustomerID } from "../../utils/storage";
import Box from "@mui/material/Box";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function FeedbackDrawer({ openFeedback, setOpenFeedback }) {
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(null);
  const [feedback, setFeedback] = useState("");

  const customerID = getCustomerID();
  const { feedbackAPI } = new AfterOnboardAPI();

  const resetState = () => {
    setRating(null);
    setFeedback("");
    setLoading(false);
  };

  const handleClose = () => {
    setOpenFeedback(false);
    resetState();
  };

  const handleSubmit = useCallback(async (isSkipped=false) => {
    if (!rating && !isSkipped) return;
    try {
      setLoading(true);
      const trimmedFeedback = typeof feedback === "string" ? feedback.trim() : "";
      const requestObj = {
        leadID: Number(localStorage.getItem("leadID")),
        status: isSkipped ? "SKIPPED" : "DONE",
        ...(!isSkipped ? { rating } : {}),
        ...(trimmedFeedback && !isSkipped ? { comments: trimmedFeedback } : {}),
      };

      const res = await feedbackAPI(requestObj);

      if (res?.statusCode === 200) {
        handleClose();
        !isSkipped && await Swal.fire({
          icon: "success",
          text: toSentenceCase(res?.message),
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      await Swal.fire({
        icon: "error",
        text: "Something went wrong. Please try again later.",
        timer: 3000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
    } finally {
      handleClose();
    }
  }, [rating, feedback, customerID, feedbackAPI]);

  useEffect(() => {
    loading ? handleShowContextualLoader("We appreciate your feedback...") : handlehideContextualLoader();
  }, [loading]);

  if (loading) {
    return null;
  }

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={openFeedback}
      onClose={handleClose}
      transitionDuration={300}
      onOpen={() => {}} // Required
      slotProps={{
        paper: {
          sx: {
            width: "100%",
            maxWidth: "480px",
            padding: "24px 17px",
            mx: "auto",
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
          },
        },
      }}
      ModalProps={{
        sx: {
          zIndex: 1050,
        },
      }}
    >
      <div className={styles.container}>
        <h3 className={styles.heading}>How are you feeling?</h3>
        <div className={styles.innerContainer}>
          <p className={`${styles.subText}`}>
            We hope your loan process went smoothly. We'd love to hear your thoughts—your feedback helps us improve.
          </p>
<div>
          <div className={`${styles.ratingLabels}`}>
            <span>NOT AT ALL LIKELY</span>
            <span>EXTREMELY LIKELY</span>
          </div>

          <div className={styles.ratingContainer}>
            {[...Array(10).keys()].map((index) => {
              const value = index + 1;
              return (
                <button
                  key={value}
                  type="button"
                  className={`${styles.ratingButton} ${rating === value ? styles.selected : ""}`}
                  onClick={() => setRating(value)}
                >
                  {value}
                </button>
              );
            })}
          </div>
            </div>
          <div className={styles.commentContainer}>
            <textarea
              id="feedback_msg"
              className={styles.commentBox}
              placeholder="Add a comment..."
              maxLength={100}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
            <div className={styles.range}>{feedback.length}/100</div>
          </div>
            <Box className={styles.actionBlock}>
              <button
                className={`${styles.formSubmitBtn} button`}
                maxLength={100}
                onClick={() => handleSubmit(false)}
                disabled={!rating}
              >
                Submit
              </button>
              <span className={styles.skip} onClick={() => handleSubmit(true)}>Skip</span>
            </Box>
        </div>
      </div>
    </SwipeableDrawer>
  );
}
